import React, { useState, useEffect } from 'react';
import { Button, DescriptionList, Field, TextInput } from '../../../../../ui';
import { Actions, Dialog, FormGrid, TextArea } from '../ui-pending';
import { toast } from 'react-toastify';
import { markcompleteLevel, courseListOfStudent, courseLevel, reGenerateCertificate } from '../../../../../Api/apiUtils';
import Select, { components, ControlProps } from 'react-select';
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';
interface CompleteLevelProps {
  studentId?: string;
  profileData: any;
}

interface GroupedCourse {
  courseId: string;
  courseName: string;
  levels: { purchasedLevel: string | null; classesCount: number }[];
}

interface CourseOption {
  value: string;
  label: string;
  levelId?: string;
}
const CompleteLevel: React.FC<CompleteLevelProps> = ({ studentId, profileData }) => {
  const studentUserId = profileData.userId;
  const [courses, setCourses] = useState<any[]>([]);
  const [groupedCourses, setGroupedCourses] = useState<GroupedCourse[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<CourseOption | null>(null);
  const [selectedCourseData, setSelectedCourseData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentLevel, setCurrentLevel] = useState<string>('');
  const [currentLevelId, setCurrentLevelId] = useState<string>('');
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [reason, setReason] = useState<string>('');
  const [courseMenuIsOpen, setCourseMenuIsOpen] = useState<boolean>(false);

  // Custom Control component to ensure entire control area opens dropdown on click
  const CustomControl = (props: ControlProps<any, false>) => {
    const { innerProps, selectProps } = props;
    const menuIsOpen = selectProps.menuIsOpen;
    const onMenuOpen = selectProps.onMenuOpen;
    
    return (
      <components.Control
        {...props}
        innerProps={{
          ...innerProps,
          onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onMouseDown) {
              innerProps.onMouseDown(e as any);
            }
          },
          onClick: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onClick) {
              innerProps.onClick(e as any);
            }
          }
        }}
      />
    );
  };

  // Handle outside clicks to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isClickInsideSelect = target.closest('.react-select-container') || 
                                   target.closest('[class*="react-select"]') ||
                                   target.closest('[id*="react-select"]') ||
                                   target.closest('[class*="css-"]');
      
      if (!isClickInsideSelect) {
        setCourseMenuIsOpen(false);
      }
    };

    if (courseMenuIsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [courseMenuIsOpen]);

  console.log("currentLevel",profileData)

  useEffect(() => {
    const fetchCourses = async () => {
      if (!studentId) return;

      try {
        const response = await courseListOfStudent(studentId);
        setCourses(response);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to fetch course list.');
        setLoading(false);
      }
    };

    fetchCourses();
  }, [studentId]);

  useEffect(() => {
    if (courses.length > 0) {
      const grouped = courses.reduce((acc: GroupedCourse[], course) => {
        const existingCourse = acc.find((c: GroupedCourse) => c.courseId === course.courseId);
        if (existingCourse) {
          existingCourse.levels.push({
            purchasedLevel: course.purchasedLevel,
            classesCount: course.classesCount,
          });
        } else {
          acc.push({
            courseId: course.courseId,
            courseName: course.courseName,
            levels: [{ purchasedLevel: course.purchasedLevel, classesCount: course.classesCount }],
          });
        }
        return acc;
      }, []);
      setGroupedCourses(grouped);
    }
  }, [courses]);

  useEffect(() => {
    const fetchCurrentLevel = async () => {
      if (!selectedCourse?.value || !studentUserId) {
        setCurrentLevel('');
        setCurrentLevelId('');
        return;
      }

      try {
        const response = await courseLevel(studentUserId, selectedCourse.value);
        if (response.status && response.status[0]) {
          setCurrentLevel(response.status[0].level_name);
          setCurrentLevelId(response.status[0].level_id);
        } else {
          setCurrentLevel('No level found');
          setCurrentLevelId('');
        }
      } catch (error) {
        console.error("Failed to fetch course level:", error);
        setCurrentLevel('Error fetching level');
        setCurrentLevelId('');
      }
    };

    fetchCurrentLevel();
  }, [selectedCourse?.value, studentUserId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedCourse?.value) {
      toast.error('Please select a course');
      return;
    }
    
    setConfirmModalOpen(true);
  };

  const handleConfirmSubmit = async () => {
    if (reason.length < 25) {
      toast.error('Please provide a reason with at least 25 characters');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        userId: studentUserId,
        courseId: selectedCourse?.value,
        levelId: currentLevelId,
        status: 2,
        isLessonUpdate:1,
        isPurchased: true,
        levelName: currentLevel,
      };

      await markcompleteLevel(payload);
      toast.success('Level marked as complete successfully');
      
      // Track Mixpanel event
      trackEvent(MixpanelEvents.COMPLETED_LEVEL, {
        page: "Complete Level in student profile",
        courseId: selectedCourse?.value,
        levelId: currentLevelId,
        levelName: currentLevel,
        reason: reason,
        studentId: studentId,
        userId: studentUserId,
        studentName: profileData.firstName
      });
      
      // Regenerate certificate after completing level
      try {
        const certificatePayload = {
          userId: studentUserId,
          userName: profileData.firstName,
          courseId: selectedCourse?.value,
        };
        
        await reGenerateCertificate(certificatePayload);
        // toast.success('Certificate regenerated successfully');
      } catch (certError) {
        console.error('Certificate regeneration failed:', certError);
        toast.warning('Level completed but certificate regeneration failed');
      }
      
      // Reset form
      setSelectedCourse(null);
      setSelectedCourseData(null);
      setCurrentLevel('');
      setCurrentLevelId('');
      setReason('');
      setConfirmModalOpen(false);
    } catch (error) {
      toast.error('Error marking level as complete');
    } finally {
      setLoading(false);
    }
  };

  const handleCourseChange = (option: CourseOption | null) => {
    setSelectedCourse(option);
    
    // Find the complete course data from the courses array
    if (option?.value) {
      const courseData = courses.find(course => course.courseId === option.value);
      setSelectedCourseData(courseData);
    } else {
      setSelectedCourseData(null);
    }
    
    // Reset level data when course changes
    setCurrentLevel('');
    setCurrentLevelId('');
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="ds-stack">
        <FormGrid>
          <Field label="Select student course">
            {(ctl) => (
              <Select
                id="courseSelect"
                inputId={ctl.id}
                value={selectedCourse}
                onChange={(newValue) => {
                  handleCourseChange(newValue);
                  setCourseMenuIsOpen(false);
                }}
                options={groupedCourses.map(course => ({
                  value: course.courseId,
                  label: course.courseName
                }))}
                placeholder="Select a course"
                isClearable
                menuIsOpen={courseMenuIsOpen}
                onMenuOpen={() => setCourseMenuIsOpen(true)}
                onMenuClose={() => setCourseMenuIsOpen(false)}
                components={{ Control: CustomControl }}
              />
            )}
          </Field>
          <Field id="currentLevel" label="Current active level">
            {(ctl) => (
              <TextInput
                {...ctl}
                type="text"
                value={currentLevel}
                disabled
                placeholder="Select a course to see current level"
              />
            )}
          </Field>
        </FormGrid>
        <Actions align="start">
          <Button
            variant="primary"
            type="submit"
            loading={loading}
            disabled={!selectedCourse?.value}
          >
            {loading ? 'Processing...' : 'Mark Level as Complete'}
          </Button>
        </Actions>
      </form>

      {/* Confirmation Modal */}
      <Dialog
        isOpen={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        title="Confirm Level Completion"
        actions={
          <>
            <Button
              variant="secondary"
              onClick={() => setConfirmModalOpen(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirmSubmit}
              loading={loading}
              disabled={reason.length < 25}
            >
              {loading ? 'Processing...' : 'Confirm Completion'}
            </Button>
          </>
        }
      >
        <div className="ds-stack">
          <Field
            id="reason"
            label="Reason for completing this level"
            hint={`Characters: ${reason.length}/25 minimum`}
          >
            {(ctl) => (
              <TextArea
                {...ctl}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Please provide a detailed reason for completing this level (minimum 25 characters)"
                rows={4}
              />
            )}
          </Field>
          <DescriptionList
            items={[
              { label: 'Course', value: selectedCourse?.label },
              { label: 'Current Level', value: currentLevel },
            ]}
          />
        </div>
      </Dialog>
    </>
  );
};

export default CompleteLevel;

